import React, { Component } from 'react';
import PropTypes from 'prop-types';
import memoize from 'memoizee';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { array_pad } from 'cityads-v3/utils/arrayUtils'

import NewsList from 'cityads-v3/components/NewsList/NewsList'

import {
  getNewsTypes,
  getOfferNews,
} from 'cityads-v3/actions/news';

const getNewsFromState = memoize(function getNewsFromState(newsIdsByOfferId, newsById, offerId) {
  return (newsIdsByOfferId[offerId] || []).map(id => newsById[id]);
});

const ITEMS_PAD = 6;

@withRouter
@connect(
  (state, props) => ({
    news: getNewsFromState(state.news.newsIdsByOfferId, state.news.newsById, props.offerId),
    newsLoading: state.news.newsIdsByOfferIdLoading[props.offerId],
    newsLoaded: state.news.newsIdsByOfferIdLoaded[props.offerId],
    newsTypesById: state.news.newsTypesById,
    newsTypesLoading: state.news.isLoadingNewsTypes,
    newsTypesLoaded: state.news.isNewsTypesLoaded,
    language: state.language.language,
  }),
  dispatch => bindActionCreators({
    getOfferNews,
    getNewsTypes,
  }, dispatch)
)
export default class News extends Component {
  static propTypes = {
    offerId: PropTypes.number,
    className: PropTypes.string,
    title: PropTypes.string,
    emptyMessage: PropTypes.string,

    news: PropTypes.arrayOf(PropTypes.object).isRequired,
    newsLoading: PropTypes.bool,
    newsLoaded: PropTypes.bool,
    newsTypesById: PropTypes.object.isRequired,
    newsTypesLoading: PropTypes.bool,
    newsTypesLoaded: PropTypes.bool,
    language: PropTypes.string,

    getOfferNews: PropTypes.func.isRequired,
    getNewsTypes: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { offerId, newsLoading, newsLoaded, newsTypesLoading, newsTypesLoaded, getOfferNews, getNewsTypes } = this.props;

    if (!newsLoading && !newsLoaded) {
      getOfferNews(offerId);
    }

    if (!newsTypesLoading && !newsTypesLoaded) {
      getNewsTypes();
    }
  }

  componentDidUpdate(prevProps) {
    const { offerId, language, getOfferNews, getNewsTypes } = this.props;

    if (language !== prevProps.language) {
      getOfferNews(offerId);
      getNewsTypes();
    }
  }

  render() {
    const { news, newsLoading, newsTypesById, newsTypesLoading, className, title, emptyMessage } = this.props;

    return (
      <NewsList
        className={className}
        title={title}
        items={array_pad(news, ITEMS_PAD, null)}
        isLoading={newsLoading}
        typesById={newsTypesById}
        isLoadingTypes={newsTypesLoading}
        emptyMessage={emptyMessage}
      />
    );
  }
}
